/*
 * Shopify Common JS
 *
 */
/* global Shopify, SmartWishlistScripts */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.postLink = function postLink(path, options = {}) {
  const method = options.method || 'post';
  const params = options.parameters || {};

  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  Object.keys(params).forEach((key) => {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

// wishlist bug fix for related/recently viewed products
const recentWrappers = document.querySelectorAll('[data-recent-wrapper]');

if (recentWrappers.length > 0) {
  recentWrappers.forEach((recentWrapper) => {
    const options = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    };

    function mCallback(mutations) {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'childList' &&
          mutation.target.nodeName === 'DIV' &&
          typeof SmartWishlistScripts === 'function'
        ) {
          SmartWishlistScripts();
        }
      });
    }

    const observer = new MutationObserver(mCallback);

    observer.observe(recentWrapper, options);
  });
}
